var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgComputer = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 43,
  height: 35,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#0F1E34",
  strokeWidth: 3.333,
  d: "M2 6.63A4.63 4.63 0 0 1 6.63 2h29.816a4.63 4.63 0 0 1 4.63 4.63v16.79a4.63 4.63 0 0 1-4.63 4.63H6.63A4.63 4.63 0 0 1 2 23.42z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#0F1E34",
  strokeLinecap: "round",
  strokeWidth: 3.333,
  d: "M14.895 32.609h14.067"
})));
export { SvgComputer as ReactComponent };
export default __webpack_public_path__ + "static/media/computer.98cbcf1a.svg";